import { Component, OnInit } from '@angular/core';

import { AlertService } from '../../services/alert.service';

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent {
    messages: any[] = [];

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getMessage().subscribe(message => {
        	if (message != null && message.toString() != "") {
        		this.messages.push(message);
			}
        });
    }

    closeAlert(index: number) {
    	this.messages.splice(index, 1);
    }
}
